import { ShieldCheck } from 'lucide-react';

interface VerifiedBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

const sizes = {
  sm: { icon: 'w-3.5 h-3.5', text: 'text-[10px]', px: 'px-1.5 py-0.5', gap: 'gap-0.5' },
  md: { icon: 'w-4 h-4', text: 'text-xs', px: 'px-2 py-0.5', gap: 'gap-1' },
  lg: { icon: 'w-5 h-5', text: 'text-sm', px: 'px-2.5 py-1', gap: 'gap-1.5' },
};

export default function VerifiedBadge({ size = 'md', showLabel = true }: VerifiedBadgeProps) {
  const s = sizes[size];
  return (
    <span className={`inline-flex items-center ${s.gap} ${s.px} rounded-full bg-blue-50 text-blue-700 font-semibold ${s.text}`}>
      <ShieldCheck className={s.icon} />
      {showLabel && 'Verified'}
    </span>
  );
}
